import styled, { css } from 'styled-components';
import starIcon from '~/assets/icons/star.svg';
import { Text } from '~/components/ui/Text';

import rowHoverImage from '../../assets/images/row_hover.png';

const StyledContainer = styled.div`
	position: relative;
	height: 58px;
	display: flex;
	align-items: center;
	cursor: pointer;

	&::before {
		content: '';
		position: absolute;
		left: -60px;
		right: -20px;
		height: 100%;
		opacity: 0;
		background-image: url(${rowHoverImage});
		background-repeat: no-repeat;
		background-clip: content-box;
		overflow-x: hidden;
		transition: opacity 0.25s ease;
		pointer-events: none;
	}

	&:hover::before,
	&.selected::before {
		opacity: 1;
	}

	&::after {
		content: '';
		position: absolute;
		left: -35px;
		width: 10px;
		height: 10px;
		border-radius: 5px;
		background-color: #fff;
		opacity: 0;
		transition: opacity 0.5s ease;
	}

	&.selected::after {
		opacity: 1;
	}
`;

const StyledFavoriteIcon = styled.img.attrs({ src: starIcon })`
	position: absolute;
	width: 20px;
	height: 20px;
	opacity: 0;
	transition: opacity 0.25s ease;
`;

const StyledTimerContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;
	justify-content: space-between;
	width: 82px;
	height: 30px;
	margin-right: 10px;
	padding: 0 7px;
	border-radius: 10px;
	background-color: rgba(255, 255, 255, 0.02);
	border: 1px solid rgba(255, 255, 255, 0.05);

	img {
		width: 16px;
		height: 16px;
		user-select: none;
		pointer-events: none;
	}

	${Text} {
		font-weight: 700;
		font-size: 14px;
		color: #ffffff;
	}
`;

const StyledVehicleNameContainer = styled.div<{ $favoriteEnabled?: boolean }>`
	display: flex;
	align-items: center;
	gap: 10px;
	margin-right: auto;
	transition: text-indent 0.25s ease;

	${StyledFavoriteIcon} {
		pointer-events: none;
	}

	${({ $favoriteEnabled }) =>
		$favoriteEnabled &&
		css`
			${StyledContainer}:hover & {
				text-indent: 30px;

				${StyledFavoriteIcon} {
					opacity: 0.1;
					pointer-events: all;
				}

				${StyledFavoriteIcon}.active {
					opacity: 1;
				}
			}
		`}
`;

const StyledVehicleName = styled.div<{ $timer?: boolean; $selected?: boolean }>`
	font-family: 'GT Walsheim Pro';
	font-size: 16px;
	color: #ffffff7f;
	transition: color 0.25s ease;

	${StyledContainer}:hover &,
	${StyledContainer}.selected & {
		font-weight: bold;
		color: #fff;
	}

	${({ $timer, $selected }) =>
		($timer || $selected) &&
		css`
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;
		`}

	${({ $selected }) =>
		$selected &&
		css`
			max-width: 220px;
		`}

	${({ $timer }) =>
		$timer &&
		css`
			max-width: 150px;
		`}

	${({ $timer, $selected }) =>
		$timer &&
		$selected &&
		css`
			max-width: 126px;
		`}
`;

const StyledCrossButtonContainer = styled.div`
	position: relative;
	width: 30px;
	height: 30px;
	margin-left: 10px;
	overflow: hidden;
`;

const StyledCrossButtonContainerAnimated = styled(StyledCrossButtonContainer)`
	width: 0;
	margin-left: 0;
	transition:
		width 0.3s,
		margin-left 0.3s;

	&.button-enter {
		width: 0;
		margin-left: 0;
	}

	&.button-enter-active,
	&.button-enter-done,
	&.button-exit {
		width: 30px;
		margin-left: 10px;
	}

	&.button-exit-active {
		width: 0;
		margin-left: 0;
	}
`;

export {
	StyledContainer,
	StyledCrossButtonContainer,
	StyledCrossButtonContainerAnimated,
	StyledFavoriteIcon,
	StyledTimerContainer,
	StyledVehicleName,
	StyledVehicleNameContainer,
};
